import RequestMethod from "@/models/client/RequestMethod";
import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import {
  RecentSharePointSitesResponse,
  SynonymPreferences,
} from "@/models/users/UserPreference";

export enum PreferenceSubPaths {
  SYNONYM = "synonyms",
  RECENT_SHAREPOINT_SITES = "recent-sharepoint-sites",
}

export type UserPreferenceServiceType = {
  getSynonymPreferences: () => RestResponse<SynonymPreferences>;
  updateSynonymPreference: (
    synonymGroupId: string,
    active: boolean
  ) => RestResponse<void>;
  updateSynonymMatchingPreference: (active: boolean) => RestResponse<void>;
  getRecentSharePointSites: () => RestResponse<RecentSharePointSitesResponse>;
  rememberSharePointSite: (
    webUrl: string,
    displayName: string
  ) => RestResponse<void>;
};

const userPreferenceServices = (
  client: RestClient,
  path: string
): UserPreferenceServiceType => ({
  getSynonymPreferences: async () => {
    return await client.fetch<SynonymPreferences>(
      RequestMethod.GET,
      `${path}/${PreferenceSubPaths.SYNONYM}`
    );
  },
  updateSynonymPreference: async (synonymGroupId, active) => {
    return await client.fetch(
      RequestMethod.POST,
      `${path}/${PreferenceSubPaths.SYNONYM}`,
      {
        synonymGroupId: synonymGroupId,
        active: active,
      }
    );
  },
  updateSynonymMatchingPreference: async (active) => {
    return await client.fetch(
      RequestMethod.PATCH,
      `${path}/${PreferenceSubPaths.SYNONYM}/matching`,
      {
        active: active,
      }
    );
  },
  getRecentSharePointSites: async () => {
    return await client.fetch<RecentSharePointSitesResponse>(
      RequestMethod.GET,
      `${path}/${PreferenceSubPaths.RECENT_SHAREPOINT_SITES}`
    );
  },
  rememberSharePointSite: async (webUrl, displayName) => {
    return await client.fetch(
      RequestMethod.POST,
      `${path}/${PreferenceSubPaths.RECENT_SHAREPOINT_SITES}`,
      { webUrl, displayName }
    );
  },
});

export default userPreferenceServices;
